<template>
	<div
		class="fixed top-0 z-[1000] flex w-full items-center justify-center gap-1 bg-gradient-to-r from-[#07b696] to-[#03a184] h-[60px] px-2 sm:px-8 md:h-8"
	>
		<span class="text-center text-base font-medium text-white">
			Our QLD office will relocate to
			<a
				href="https://maps.app.goo.gl/aRoB76orSmuU2xtW7"
				target="_blank"
				class="text-white"
			>
				109B Links Ave S, Eagle Farm QLD 4009
			</a>
			on 15 December 2025.
		</span>
	</div>
</template>

<script setup lang="ts"></script>
